<template>
  <div class="analysis-charts">
    <v-chart
      ref="bar"
      height="254"
      :forceFit="true"
      :options="options"
      :padding="['auto', 'auto', '40', '50']"
    />
  </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
export default {
  components: {
    'v-chart': ECharts,
  },
  props: ['chartsData'],
  data() {
    return {
      options: {
        title: {
          show: true, //是否显示标题，默认显示，可以不设置
          text: this.chartsData.name, //图表标题文本内容
          textStyle: {
            //标题内容的样式
            color: '#000', //
            fontWeight: 'bold', //可选normal(正常)，bold(加粗)，bolder(加粗)，lighter(变细)，100|200|300|400|500...
            fontSize: 14, //主题文字字体大小，默认为18px
          },
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: '10%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.chartsData.xaxis,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            //name: this.chartsData.name,
            nameTextStyle: {
              fontSize: '16',
            },
            type: 'value',
            axisLine: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '直接访问',
            type: 'bar',
            barWidth: 30,
            data: this.chartsData.yaxis,
            markLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
          },
        ],
      },
    }
  },
}
</script>
<style lang="less" scoped>
.analysis-charts {
  margin-right: 5%;
  width: 25%;
  height: 100%;
  display: inline-block;
  /deep/ .echarts {
    width: 100%;
    display: inline-block;
    height: 254px;
  }
}
</style>
